var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBitCointIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6 26.3999C34.825 29.4999 30 27.9249 28.5 27.4999L29.875 22.0499C31.425 22.4999 36.4 23.1499 35.6 26.3999ZM27.825 30.2999L26.325 36.3249C28.175 36.7999 33.9 38.6249 34.75 35.2249C35.65 31.6749 29.675 30.7499 27.825 30.2999ZM54.25 36.0499C50.9 49.4499 37.35 57.5999 23.95 54.2499C10.55 50.8999 2.4075 37.3499 5.75 23.9499C6.54411 20.7651 7.95783 17.7679 9.91043 15.1296C11.863 12.4913 14.3162 10.2634 17.13 8.57335C19.9437 6.88326 23.0628 5.76403 26.3091 5.27957C29.5555 4.79511 32.8654 4.95491 36.05 5.74986C49.425 9.09986 57.575 22.6499 54.25 36.0499ZM35.525 20.1249L36.65 15.6249L33.9 14.9999L32.8 19.3249C32.075 19.1499 31.35 18.9749 30.6 18.8249L31.7 14.3999L28.975 13.7499L27.85 18.2249C27.25 18.0749 26.65 17.9499 26.1 17.7999L22.325 16.8499L21.575 19.7749C21.575 19.7749 23.625 20.2499 23.575 20.2749C24.7 20.5499 24.9 21.2499 24.85 21.8749L21.775 34.1999C21.65 34.5499 21.25 34.9999 20.525 34.8749C20.55 34.8999 18.525 34.3749 18.525 34.3749L17.175 37.4999L20.725 38.3999C21.4 38.5749 22.05 38.7499 22.7 38.8999L21.55 43.4499L24.3 44.1499L25.425 39.6249C26.175 39.8249 26.9 39.9999 27.6 40.1999L26.475 44.6749L29.225 45.3749L30.375 40.8249C35 41.6999 38.55 41.3499 40 37.1249C41.25 33.7499 40 31.7499 37.5 30.4749C39.3 29.9999 40.65 28.8749 41.025 26.4249C41.525 23.0999 38.975 21.3249 35.525 20.1249Z",
    fill: "#1395DC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitCointIcn);
export default __webpack_public_path__ + "static/media/bit_coint_icn.2eaac2f00fa5b37608d99e5405ada001.svg";
export { ForwardRef as ReactComponent };